import { createRouter, createWebHistory } from 'vue-router'
import { getToken } from '../api'
import Staking from '../views/deposit/Staking.vue'

// Lazy load components
const Home = () => import('../views/Home.vue')
const Login = () => import('../views/Login.vue')
const Register = () => import('../views/Register.vue')
const ForgetPassword = () => import('../views/ForgetPassword.vue')
const RecoverKey = () => import('../views/RecoverKey.vue')
const TradePage = () => import('../views/TradePage.vue')
const WalletPage = () => import('../views/WalletPage.vue')
const DepositPage = () => import('../views/DepositPage.vue')
const DepositHistory = () => import('../views/DepositHistory.vue')
const WithdrawPage = () => import('../views/WithdrawPage.vue')
const WithdrawHistory = () => import('../views/WithdrawHistory.vue')
const SupportPage = () => import('../views/SupportPage.vue')
const TicketPage = () => import('../views/TicketPage.vue')
const MessagePage = () => import('../views/MessagePage.vue')
const ContactPage = () => import('../views/ContactPage.vue')
const AboutPage = () => import('../views/AboutPage.vue')
const InfoPage = () => import('../views/profile/InfoPage.vue')
const ChangePassword = () => import('../views/profile/ChangePassword.vue')
const SecurityPage = () => import('../views/profile/SecurityPage.vue')
const LuckyDraw = () => import('../views/lucky/LuckyDraw.vue')
const LuckyDrawDetail = () => import('../views/lucky/LuckyDrawDetail.vue')
const MyLuckyDraws = () => import('../views/lucky/MyLuckyDraws.vue')
const MyStakes = () => import('../views/deposit/MyStakes.vue')
const BorrowPage = () => import('../views/loan/BorrowPage.vue')
const BorrowDetails = () => import('../views/loan/BorrowDetails.vue')
const BorrowConfirm = () => import('../views/loan/BorrowConfirm.vue')
const MyLoans = () => import('../views/loan/MyLoans.vue')
const LoanDetails = () => import('../views/loan/LoanDetails.vue')
const CreditPage = () => import('../views/credit/CreditPage.vue')
const CollectCredit = () => import('../views/credit/CollectCredit.vue')
const DepositWithLoan = () => import('../views/deposit/DepositWithLoan.vue')
const CoinList = () => import('../views/CoinList.vue')
const NotificationsPage = () => import('../views/NotificationsPage.vue')
// TODO: Create these components
// const Facilities = () => import('../views/Facilities.vue')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: false }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false, guestOnly: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { requiresAuth: false, guestOnly: true }
  },
  {
    path: '/forget-password',
    name: 'ForgetPassword',
    component: ForgetPassword,
    meta: { requiresAuth: false, guestOnly: true }
  },
  {
    path: '/recover-key',
    name: 'RecoverKey',
    component: RecoverKey,
    meta: { requiresAuth: false, guestOnly: true }
  },
  // Protected routes - require authentication
  {
    path: '/trade',
    name: 'Trade',
    component: TradePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/wallet',
    name: 'Wallet',
    component: WalletPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/wallet/:id',
    name: 'WalletDetail',
    component: () => import('../views/WalletDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/deposit',
    name: 'Deposit',
    component: DepositPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/deposit-history',
    name: 'DepositHistory',
    component: DepositHistory,
    meta: { requiresAuth: true }
  },
  {
    path: '/withdraw',
    name: 'Withdraw',
    component: WithdrawPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/withdraw-history',
    name: 'WithdrawHistory',
    component: WithdrawHistory,
    meta: { requiresAuth: true }
  },
  {
    path: '/support',
    name: 'Support',
    component: SupportPage,
    meta: { requiresAuth: false }
  },
  {
    path: '/ticket',
    name: 'Ticket',
    component: TicketPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/ticket/:id',
    name: 'TicketDetail',
    component: MessagePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage,
    meta: { requiresAuth: false }
  },
  {
    path: '/about',
    name: 'About',
    component: AboutPage,
    meta: { requiresAuth: false }
  },
  {
    path: '/profile/info',
    name: 'ProfileInfo',
    component: InfoPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/profile/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: { requiresAuth: true }
  },
  {
    path: '/profile/security',
    name: 'ProfileSecurity',
    component: SecurityPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/lucky-draw',
    name: 'LuckyDraw',
    component: LuckyDraw,
    meta: { requiresAuth: true }
  },
  {
    path: '/lucky-draw/:id',
    name: 'LuckyDrawDetail',
    component: LuckyDrawDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-lucky-draws',
    name: 'MyLuckyDraws',
    component: MyLuckyDraws,
    meta: { requiresAuth: true }
  },
  {
    path: '/staking',
    name: 'Staking',
    component: Staking,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-stakes',
    name: 'MyStakes',
    component: MyStakes,
    meta: { requiresAuth: true }
  },
  {
    path: '/credit',
    name: 'CreditPage',
    component: CreditPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/credit/collect',
    name: 'CollectCredit',
    component: CollectCredit,
    meta: { requiresAuth: true }
  },
  {
    path: '/loan/borrow',
    name: 'BorrowPage',
    component: BorrowPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/loan/borrow-details',
    name: 'BorrowDetails',
    component: BorrowDetails,
    meta: { requiresAuth: true }
  },
  {
    path: '/loan/borrow-confirm',
    name: 'BorrowConfirm',
    component: BorrowConfirm,
    meta: { requiresAuth: true }
  },
  {
    path: '/loans/my-loans',
    name: 'MyLoans',
    component: MyLoans,
    meta: { requiresAuth: true }
  },
  {
    path: '/loans/:id',
    name: 'LoanDetails',
    component: LoanDetails,
    meta: { requiresAuth: true }
  },
  {
    path: '/deposit/with-loan',
    name: 'DepositWithLoan',
    component: DepositWithLoan,
    meta: { requiresAuth: true }
  },
  {
    path: '/coins',
    name: 'CoinList',
    component: CoinList,
    meta: { requiresAuth: false }
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: NotificationsPage,
    meta: { requiresAuth: true }
  },
  // TODO: Uncomment when these components are created
  // {
  //   path: '/facilities',
  //   name: 'Facilities',
  //   component: Facilities,
  //   meta: { requiresAuth: true }
  // },
  // 404 - Not Found
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const chunkReloadKey = 'router:chunk-reload'

router.onError((error, to) => {
  const message = error?.message || ''
  const isChunkLoadError = error?.name === 'ChunkLoadError' ||
    /loading chunk|failed to fetch dynamically imported module|importing a module script failed|load failed/i.test(message)

  if (!isChunkLoadError) return

  const targetPath = to?.fullPath || window.location.pathname
  try {
    if (sessionStorage.getItem(chunkReloadKey) === targetPath) return
    sessionStorage.setItem(chunkReloadKey, targetPath)
  } catch (storageError) {
    console.warn('Could not persist chunk reload state:', storageError)
    return
  }
  window.location.assign(targetPath)
})

router.afterEach((to) => {
  try {
    if (sessionStorage.getItem(chunkReloadKey) === to.fullPath) {
      sessionStorage.removeItem(chunkReloadKey)
    }
  } catch (storageError) {
    console.warn('Could not clear chunk reload state:', storageError)
  }
})

// Navigation guard - Check authentication
router.beforeEach((to, from, next) => {
  const token = getToken()
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const guestOnly = to.matched.some(record => record.meta.guestOnly)

  if (requiresAuth && !token) {
    // Route requires auth but user is not authenticated
    next({ name: 'Login', query: { redirect: to.fullPath } })
  } else if (guestOnly && token) {
    // Route is for guests only but user is authenticated
    next({ name: 'Home' })
  } else {
    next()
  }
})

export default router

